<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Requerimento Único"
    descricaoRelatorio="Formulário cadastral único do médico (inscrição, dados pessoais, formação, endereços e e-mails)."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'requerimento-unico-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-muted-color">O requerimento será emitido para o médico selecionado, reunindo em um único formulário seus dados de inscrição, dados pessoais, situação militar, formação, endereços e e-mails.</p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Requerimento"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
